export default __webpack_public_path__ + "static/media/825-8254341_404-error-not-found.3ff78e1f.png";